export const CONFIRM_CODE = {
  CONFIRM_CODE_REQUEST: "CONFIRM_CODE_REQUEST",
  CONFIRM_CODE_SUCCESS: "CONFIRM_CODE_SUCCESS",
  CONFIRM_CODE_FAILURE: "CONFIRM_CODE_FAILURE",
  CONFIRM_CODE_CLEAR: "CONFIRM_CODE_CLEAR",
};